import { memo } from "react"
import { cx } from "@emotion/css"
import type { Area } from "./types"

import { getPrefixedClassNames, styles } from "./styles"
import { HeaderCell } from "./HeaderCell"
import { useTableContext } from "./context"
import { ISortingByColumn } from "models/spots"

export type GridHeaderProps = {
  area: Area
  sortingByColumn?: ISortingByColumn
}
export const GridHeader = memo(function (props: GridHeaderProps) {
  const { area, sortingByColumn } = props

  const { columnManager: cm } = useTableContext()

  return (
    <div
      data-component="data-grid-header"
      data-area={area}
      role="row"
      className={cx(
        styles.row,
        styles.header,
        getPrefixedClassNames("header-row", `header-row--${area}`),
      )}
    >
      {cm.getColumnsByArea(area).map((column, idx) => (
        <HeaderCell
          key={column.id + idx}
          column={column}
          area={area}
          sortingByColumn={sortingByColumn}
        />
      ))}
    </div>
  )
})
